import {config} from 'config/env';

import {graphqlRequest} from './api';

export const campaignGraphqlRequest = async <ResponseBody = any, Variables = any>(
  query: string,
  variables: Variables
) => {
  return graphqlRequest<ResponseBody, Variables>(config.CAMPAIGN_SERVICE_URL, query, variables);
};

export const userGraphqlRequest = async <ResponseBody = any, Variables = any>(query: string, variables: Variables) => {
  return graphqlRequest<ResponseBody, Variables>(config.USER_API_ENDPOINT, query, variables);
};

export const basketGraphqlRequest = async <ResponseBody = any, Variables = any>(
  query: string,
  variables: Variables
) => {
  return graphqlRequest<ResponseBody, Variables>(config.BASKET_API_ENDPOINT, query, variables);
};

export const productGraphqlRequest = async <ResponseBody = any, Variables = any>(
  query: string,
  variables: Variables
) => {
  return graphqlRequest<ResponseBody, Variables>(config.PRODUCT_API_ENDPOINT, query, variables);
};
